<template>
    <simple-layout>
        <basic-card>
            <template slot="header">
                Dashboard editation
            </template>
            <form-wrapper>
                <form-text-input caption="Name" v-model="dashboard.displayName"/>
                <form-number-input caption="Columns" v-model="dashboard.layout"/>
                <form-checkbox-input caption="Is home?" v-model="dashboard.home"/>
            </form-wrapper>
            <div style="position: relative; display: flex; flex-flow: row; justify-content: space-around;">
                <simple-button @press="deleteThis" v-if="dashboard.id != undefined">Delete</simple-button>
                <simple-button @press="save">{{$t("save")}}</simple-button>

            </div>
        </basic-card>
        <simple-layout horizontal v-if="dashboard.layout != undefined">
            <simple-layout class="dashboard-column" v-for="(colNum, colIdx) in +dashboard.layout">
                <add-widget-card @press="addWidget(colIdx)"/>
                <draggable :list="dashboard.content[colIdx]" group="widgets" style="min-height: 250px; padding-bottom: 200px;" handle=".handle">
                    <template v-for="(widget, widgetIdx) in dashboard.content[colIdx]">
                        <edit-widget-card v-model="dashboard.content[colIdx][widgetIdx]"
                                          @deleteRequested="dashboard.content[colIdx].splice(widgetIdx, 1)"/>
                    </template>
                </draggable>
            </simple-layout>
        </simple-layout>
    </simple-layout>
</template>

<script>
    import SimpleLayout from "../components/layout/SimpleLayout";
    import BasicCard from "../components/layout/BasicCard";
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import SimpleButton from "../components/button/SimpleButton";
    import FormSelectInput from "../components/form/FormSelectInput";
    import AddWidgetCard from "../components/dashboards/AddWidgetCard";
    import EditWidgetCard from "../components/dashboards/EditWidgetCard";
    import {mapGetters} from "vuex";
    import FormNumberInput from "../components/form/FormNumberInput";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    export default {
        name: "SingleDashboardEditView",
        components: {
            FormCheckboxInput,
            FormNumberInput,
            EditWidgetCard,
            AddWidgetCard, FormSelectInput, SimpleButton, FormTextInput, FormWrapper, BasicCard, SimpleLayout},
        data() {
            return {
                dashboard: {
                    content: []
                }
            }
        },
        methods: {
            deleteThis() {
                this.$store.dispatch('dashboards/deleteDashboard', this.dashboard)
                .then(() => {
                    this.$router.push("/dashboards/view/home")

                });
            },
            save() {
                this.$store.dispatch('dashboards/saveDashboard', { ... this.dashboard, content: JSON.stringify(this.dashboard.content.filter((ct, idx) => idx < this.dashboard.layout)) } )
                .then(() => {
                    this.$store.dispatch('dashboards/refreshDashboards');
                })
            },
            addWidget(colIdx) {
                if(this.dashboard.content[colIdx] == undefined) {
                    this.$set(this.dashboard.content, colIdx, []);
                }
                const actualColumn = this.dashboard.content[colIdx];
                actualColumn.push({options: {}})
            }
        },
        mounted() {
            if(this.$route.params.dashboardId == 'new') return;
            this.dashboard.id = this.actualDashboard.id;
            this.dashboard.displayName = this.actualDashboard.displayName
            this.dashboard.content = this.actualDashboard.content;
            this.$set(this.dashboard, 'content', JSON.parse(this.dashboard.content));
            this.$set(this.dashboard, 'layout', this.dashboard.content.length);
            this.$set(this.dashboard, 'home', this.actualDashboard.home);
            this.$store.dispatch(`accountQueries/refreshAccountQueries`);
        },
        computed: {
            ... mapGetters({"dashboards": "dashboards/dashboards"}),
            actualDashboard() {
                return this.dashboards.find(dashboard => dashboard.id == this.$route.params.dashboardId)
            }
        },
        watch: {
            'dashboard.layout': {
                handler(newVal) {
                    if(this.dashboard.content.length != newVal) {
                        for(var colIdx = 0; colIdx < newVal; colIdx++) {
                            if(this.dashboard.content[colIdx] == undefined) {
                                this.$set(this.dashboard.content, colIdx, []);
                            }
                        }

                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-column>div>* {
        margin-top: 20px;
    }
</style>